
export const isScrolledToBottom = node => {
  if (!node) return false
  const { scrollHeight, scrollTop, offsetHeight } = node
  const distanceFromBottom = (scrollHeight - offsetHeight) - scrollTop
  return distanceFromBottom < 5
}
